(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("angular-telephone-filter", [], factory);
	else if(typeof exports === 'object')
		exports["angular-telephone-filter"] = factory();
	else
		root["angular-telephone-filter"] = factory();
})(this, function() {
return 


/** WEBPACK FOOTER **
 ** webpack/universalModuleDefinition
 **/